import React from 'react';

export default function UnifiedChatLoadingOverlay({ styles, text = 'Loading chat...' }) {
  return (
    <div style={{ ...styles.chatLoadingOverlay, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ ...styles.chatLoadingWrap, display: 'flex', alignItems: 'center', gap: 8 }}>
        <span className="spinner" style={{ width: 16, height: 16, border: '2px solid #0f5bd7', borderTop: '2px solid #fff', borderRadius: '50%', display: 'inline-block', animation: 'spin 1s linear infinite' }} />
        <span style={styles.chatLoadingText}>{text}</span>
        <style>{`@keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
